var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7562 10.5894C24.8789 10.5894 16.942 10.5894 12.0085 15.5194C7.08203 20.4494 7.08203 28.3862 7.08203 44.2564C7.08203 60.1267 7.08203 68.0635 12.012 72.9935C16.9456 77.9235 24.8824 77.9235 40.7597 77.9235C56.637 77.9235 64.5739 77.9235 69.5074 72.9935C74.4374 68.0635 74.4374 60.1267 74.4374 44.2564V42.4856",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7031 74.3395C32.6135 57.5095 49.3656 35.1935 74.3698 51.9314M63.7342 7.07617V35.4378M77.915 21.1685L49.5462 21.2216",
    stroke: "#034A73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMedia);
export default __webpack_public_path__ + "static/media/add_media.e3e9e22ab14ff28d17c12045cca34b8d.svg";
export { ForwardRef as ReactComponent };